import { z } from 'zod';

const ArchivoLicitacionSchema = z.object({
  id: z.number(),
  nombre: z.string(),
  url_externa: z.string(),
  path_local: z.string()
});

const PreguntaRespuestaLicitacionSchema = z.object({
  texto: z.string(),
  tipo: z.string(),
  orden: z.number()
});

const JsonMetadataSchema = z.any();

const LicitacionDetalleDataSchema = z.object({
  resumen_aprobado_filtro_llm: z.boolean().nullable(),
  estado_notificacion: z.string(),
  usuario_ultima_actualizacion_id: z.number().nullable(),
  fecha_resumen_procesado: z.string().nullable(),
  estado_licitacion: z.string(),
  nombre: z.string(),
  tematica_id: z.number(),
  filtro_resumen_aprobado: z.boolean().nullable(),
  codigo_externo: z.string(),
  url_ficha_oficial: z.string().nullable().optional(),
  criterios_evaluacion: z.string().nullable().optional(),
  resumen_procesado_filtro_palabras: z.boolean().nullable(),
  archivos_descargados: z.boolean().nullable(),
  codigo_estado: z.number(),
  resumen_aprobado_filtro_palabras: z.boolean().nullable(),
  archivos_procesados: z.boolean().nullable(),
  fecha_cierre: z.string().nullable(),
  fecha_archivos_procesados: z.string().nullable(),
  id: z.number(),
  resumen_procesado_filtro_llm: z.boolean().nullable(),
  filtro_archivos_aprobado: z.boolean().nullable(),
  fecha_creacion: z.string().nullable(),
  resumen: z.string().nullable(),
  json_metadata: JsonMetadataSchema.nullable(),
  fecha_actualizacion: z.string().nullable(),
  resumen_llm: z.string().nullable(),
  resumen_general: z.string().nullable(),
  fuentes_resumen_general: z.any().nullable().optional(),
  puntaje: z.number().nullable(),
  puntaje_archivos: z.number().nullable().optional(),
  resumen_archivos_llm: z.string().nullable().optional(),
  requisitos_postulacion: z.string().nullable().optional(),
  fecha_adjudicacion: z.string().nullable(),
  fecha_postulacion: z.string().nullable(),
  adjudicado: z.boolean().nullable(),
  postulado: z.boolean().nullable(),
  visto: z.array(z.number()),
  contenido_ficha: z.string().nullable().optional()
});

export const LicitacionDetalleResponseSchema = z.object({
  description: z.string(),
  status_code: z.number(),
  archivos: z.array(ArchivoLicitacionSchema),
  preguntas_y_respuestas: z.array(PreguntaRespuestaLicitacionSchema),
  visto: z.boolean(),
  data: LicitacionDetalleDataSchema
});

export type LicitacionDetalleResponse = z.infer<typeof LicitacionDetalleResponseSchema>;
export type LicitacionDetalleData = z.infer<typeof LicitacionDetalleDataSchema>;
export type ArchivoLicitacion = z.infer<typeof ArchivoLicitacionSchema>;
export type PreguntaRespuestaLicitacion = z.infer<typeof PreguntaRespuestaLicitacionSchema>; 